import React from 'react'
import { Loading } from '@myxplor/ui'
import { FormDisplayErrors } from '@myxplor/forms'
import { ShowHide } from '../../../../ui/record-display'
import LocalAsyncStore from '../../../../local-async-store'
import OccurrenceRow from './views/occurrence-row'
import { hasAvailableAction } from '../../../../ui/gov-actions'
import './views/ccs-enrolment-occurrences.css'

const available = record => hasAvailableAction(record, 'view_occurrences')

const apiEndPoint = ({ gov_id }) => `/api/ccs-enrolments/${gov_id}/occurrences`

const OccurrenceDisplay = ({ occurrences }) => {
  const { loading, data } = occurrences

  if (!data || loading) return <Loading>Loading occurrences</Loading>
  if (data.length === 0) return <FormDisplayErrors errors={'No occurrences found for enrolment'} />

  return (
    <div className="enrolmentOccurrence-wrapper">
      <div className="enrolmentOccurrence-info">
        <div className="infoCenter">
          Please note: Occurrence numbers are created by the government in the order that enrolment
          occurrences are generated. These are used as a reference number and may not reflect a
          chronological timeline.
        </div>
      </div>
      {data.map(occurrence => (
        <OccurrenceRow key={occurrence.occurrence_number} occurrence={occurrence} />
      ))}
    </div>
  )
}

const Occurrences = LocalAsyncStore('occurrences', OccurrenceDisplay, apiEndPoint)

export const EnrolmentOccurrences = ({ enrolment }) => {
  if (!available(enrolment)) return null

  return (
    <ShowHide label="occurrences">
      <Occurrences gov_id={enrolment.gov_id} />
    </ShowHide>
  )
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/ccs-enrolment-occurrences/index.js